export class MalformedJsonException extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, MalformedJsonException.prototype);
  }
}
